export default "__VITE_ASSET__Dvd8SuLL__"